export const FerramentasEEPIIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1667 4.16667V7.5C14.1667 8.42047 13.4205 9.16667 12.5 9.16667H5.83333C3.99238 9.16667 2.5 7.67428 2.5 5.83333V5.83333C2.5 3.99238 3.99238 2.5 5.83333 2.5H12.5C13.4205 2.5 14.1667 3.24619 14.1667 4.16667Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.114 3.75H15.8334C16.2936 3.75 16.6667 4.1231 16.6667 4.58333V6.25C16.6667 6.71024 16.2936 7.08333 15.8334 7.08333H14.1667"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 5.41667H18.3334"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83325 5.83329H7.99865"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.58341 9.16663L7.91675 14.1666"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9.16663V10.3553C12.5 11.0795 11.9129 11.6666 11.1886 11.6666H8.75"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 14.1667L5.42495 9.14185"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.5"
        y="14.1666"
        width="6.66667"
        height="3.33333"
        rx="1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
